import type { SortDirection } from '../../../api/types.ts';

export const prepareOrderingForBackend = (sortBy?: string, sortDirection?: SortDirection) => {
  if (!sortBy) return;
  if (sortDirection === 'desc') {
    return `-${sortBy}`;
  }
  return sortBy;
};
